export default __webpack_public_path__ + "static/media/22.a6f754f5.jpeg";